export const styles = (theme) => ({
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  rootTypography: {
    fontWeight: 700,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    width: "100%",
  },
  apiKey: {
    marginTop: theme.spacing(2),
  },
  iconDeleteImage: {
    right: 0,
    width: "2rem",
    height: "2rem",
    position: "absolute",
    backgroundColor: "#7373733b",
    top: 0,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  colorIcon: {
    color: "#939393",
  },
  avatar: {
    margin: 0,
  },
  card: {
    position: "relative",
    width: "100%",
  },
  bigAvatar: {
    width: "9vw",
    height: "9vw",
    margin: 0,
  },
  title: {
    fontSize: "1.2rem",
  },
  cardHeader: {
    margin: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: "1px solid #ccc",
    flexDirection: "column",
    textAlign: "center",
  },
  formControl: {
    // margin: theme.spacing(1),
    width: "100%",
  },
  // tabsRoot: {
  //   borderBottom: '1px solid #e8e8e8',
  // },
  subheader: {
    wordBreak: "break-word",
  },
  tabsRoot: {
    borderBottom: "1px solid #e8e8e8",
  },
  selectedMenu: {
    textAlign: "left",
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  tabRoot: {
    textTransform: "initial",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      color: "#1e6bcc",
      opacity: 1,
    },
    "&$tabSelected": {
      color: "#1e6bcc",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#1e6bcc",
    },
  },
  selected: {
    color: "#000 !important",
    opacity: "1 !important",
  },
  tabsFixed: {
    overflowX: "auto !important",
  },
  typography: {
    padding: theme.spacing(3),
  },
  textField: {
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(0),
    width: "100%",
  },
  container: {
    height: "100%",
    width: "100%",
  },
  containerImage: {
    position: "relative",
    borderRadius: "50%",
    margin: "auto",
    width: "8vw",
    height: "8vw",
    // border: '2px solid #F2F2F2',
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
  },
  camera: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "2rem",
    height: "2rem",
    marginTop: "65%",
    marginLeft: "65%",
    border: "4px solid #fff",
    backgroundColor: " #ff513f",
    borderRadius: "50%",
  },
  iconCamera: {
    width: "1.3rem",
  },
});
